(function statisticsFindControllerDefinition() {
    'use strict';

    angular.module('StatisticsRRHH')
        .controller('StatisticsFindController', [
                '$q', '$filter', '$scope', '$state', 'errorsExtend', 'processService', 'configViewService', '$translate', 'storageService', 'containerTypeService', 'documentContainerService', '$window', 'fileDownloader',
                function statisticsFindController($q, $filter, $scope, $state, errors, processService, configViewService, $translate, storageService, containerTypeService, documentContainerService, $window, fileDownloader) {
                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });

                    $scope.accordionState = {
                        isOpen: true
                    };

                    $scope.createFilters = function () {
                        var idOu = $scope.find.organizationalUnit ? $scope.find.organizationalUnit.id : undefined;

                        var filters = {
                            name: $scope.find.name,
                            processTypeId: $scope.find.processType.id,
                            organizationalUnitId: idOu,
                            processStatesIds: [],
                            metadatas: [],
                            dateFrom: $scope.find.dateFrom,
                            dateTo: $scope.find.dateTo,
                            itemPerPage: $scope.data.itemPerPage,
                            //page: $scope.data.currentPage
                        };

                        $scope.find.showNoData = false;

                        $scope.find.processType.metadatas.forEach(function (meta) {
                            filters.metadatas.push(meta);
                        });

                        if ($scope.find.selectedStates && $scope.find.selectedStates.length > 0) {
                            $scope.find.selectedStates.forEach(function (state) {
                                filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                            });
                        } else {
                            $scope.find.processType.states.forEach(function (state) {
                                filters.processStatesIds = filters.processStatesIds.concat(state.ids);
                            });
                        }

                        return filters;
                    };

                    $scope.executeFind = function () {
                        var filters = $scope.createFilters();

                        return processService.advancedGet(filters).then(function (result) {
                            $scope.paychecks = [];
                            $scope.paychecksGrid = [];
                            $scope.data.totalItems = result.count;
                            $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                            $scope.data.to = ($scope.data.from + $scope.data.itemPerPage) - 1;
                            result.values.forEach(function (value) {
                                var r = value;
                                r.metadatas = [];

                                $scope.find.processType.headers.forEach(function (header) {
                                    var metadataFound = $filter('filter')(value.metadataValues, { systemName: header.systemName }, true);
                                    if (metadataFound && metadataFound.length != 0) {
                                        var metadataDescription = metadataFound[0].value;
                                        filters.metadatas.forEach(function (value) {
                                            var metadataOptionFound = $filter('filter')(value.metadataOptions, { value: metadataFound[0].value }, true);
                                            if (metadataOptionFound && metadataOptionFound.length != 0) {
                                                metadataDescription = metadataOptionFound[0].description;
                                            }
                                        });
                                        r.metadatas.push({ value: metadataDescription, type: metadataFound[0].type, mask: header.mask });
                                    } else {
                                        r.metadatas.push({ value: null, type: null, mask: null });
                                    }
                                });

                                $scope.paychecks.push(r);
                            });

                            if ($scope.paychecks.length == 0) {
                                $scope.find.showNoData = true;
                                $scope.find.showChart = false;
                            }

                            if ($scope.paychecks.length > 0) {
                                $scope.data.to = Math.min($scope.data.itemPerPage * $scope.data.currentPage, $scope.data.totalItems);
                                $scope.paychecksGrid = $scope.paychecks.slice($scope.data.from - 1, $scope.data.to);
                                $scope.accordionState.isOpen = false;
                                $scope.find.showResult = true;
                                $scope.find.showChart = true;
                                $scope.fillAccordion();
                                $scope.fillChart();
                            }
                        }, function (error) {
                            errors.showError(error);
                        });
                    };

                    $scope.findAction = function () {
                        if (!$scope.statisticsFind.$valid) {
                            $scope.statisticsFind.$setSubmitted();
                            return errors.showError('VerifyFormData');
                        }

                        storageService.setStatisticsRRhhFilter($scope.find);

                        return $scope.executeFind();
                    };

                    $scope.loadPreFilters = function () {
                        if (!$scope.find.processType) {
                            var found = $filter('filter')($scope.processTypes, { preSelected: true }, true);
                            $scope.find.processType = angular.copy(found[0] || $scope.processTypes[0]);
                        }

                        $scope.find.selectedStates = $filter('filter')($scope.find.processType.states, { preSelected: true }, true);
                    };

                    $scope.cleanFilters = function () {
                        $scope.accordionState.isOpen = true;
                        storageService.clearStatisticsRRhhFilter();
                        $scope.find = storageService.getStatisticsRRhhFilter();

                        $scope.items = [];

                        $scope.data = {
                            currentPage: 1,
                            totalItems: 0,
                            itemPerPage: 15,
                            from: 0
                        }

                        $scope.loadPreFilters();

                        angular.forEach($scope.processTypes, function (item) {
                            if (item.id === $scope.find.processType.id) {
                                $scope.find.processType.metadatas = angular.copy(item.metadatas);
                            }
                        });
                    };

                    $scope.fillAccordion = function () {
                        $scope.paychecks.forEach(function (doc) {
                            var accordionIsOpen = false;
                            Object.defineProperty(doc, "accordionIsOpen", {
                                get: function () { return accordionIsOpen; },
                                set: function (newValue) {
                                    if (event.target.id !== "options" && !(event.target.offsetParent !== null && event.target.offsetParent.id === "options")) {
                                        if (event.target.offsetParent !== null && event.target.offsetParent.offsetParent.id === "p") {
                                            accordionIsOpen = newValue;
                                        }
                                    }
                                }
                            });
                        });
                    };

                    $scope.fillChart = function () {
                        var rows = [];

                        $scope.find.processType.states.forEach(function (states) {
                            var result = $filter('filter')($scope.paychecks, function (item) {
                                return states.ids.indexOf(item.stateId) >= 0;
                            });

                            rows.push({
                                c: [
                                    { v: states.name },
                                    { v: result.length }
                                ]
                            });
                        });

                        $scope.chartData = {
                            options: {
                                title: $filter('translate')('StatisticsRRHHChartTitle'),
                                width: 600,
                                height: 400,
                                slices: {
                                    0: { color: 'red' },
                                    1: { color: 'orange' },
                                    2: { color: 'green' }
                                }
                            },
                            rows: rows
                        };
                    };

                    $scope.selectProcessType = function (processType) {
                        $scope.find.processType = angular.copy(processType);
                        $scope.items = [];
                        $scope.find.showResult = false;
                        $scope.data = {
                            currentPage: 1,
                            totalItems: 0,
                            itemPerPage: 15,
                            from: 0
                        }

                        $scope.loadPreFilters();
                    };

                    $scope.loadMetadata = function (item) {
                        var processType = {
                            name: item.name,
                            id: item.processTypeId,
                            preSelected: item.preSelected,
                            states: item.groupStates,
                            metadatas: [],
                            headers: []
                        };

                        item.metadatas.forEach(function (metadata) {
                            if (metadata.searchCriteria) {
                                processType.metadatas.push({
                                    idObject: item.name.replace(/ /g, '_') + metadata.systemName,
                                    metadataId: metadata.metadataId,
                                    metadataValueFrom: undefined,
                                    metadataValueTo: undefined,
                                    metadataSearchTypeFrom: undefined,
                                    metadataSearchTypeTo: undefined,
                                    metadataType: metadata.metadataType != null ? metadata.metadataType.toLowerCase() : undefined,
                                    metadataSystemName: metadata.systemName,
                                    metadataLabel: metadata.searchCriteria.name,
                                    metadataReadOnly: !metadata.searchCriteria.isEditable,
                                    metadataIsRequired: metadata.searchCriteria.isRequired,
                                    metadataEnabled: true,
                                    metadataOptions: metadata.metadataOptionValues,
                                    maskOptions: metadata.metadataMaskOption,
                                    order: metadata.searchCriteria.order
                                });
                            }

                            if (metadata.resultCriteria) {
                                processType.headers.push({ label: metadata.resultCriteria.name, systemName: metadata.systemName, order: metadata.resultCriteria.order, mask: metadata.resultCriteria.mask });
                            }

                        });

                        processType.metadatas.sort(function (a, b) {
                            return a.order - b.order;
                        });

                        processType.headers.sort(function (a, b) {
                            return a.order - b.order;
                        })

                        $scope.processTypes.push(processType);
                    };

                    $scope.loadViewOptions = function () {
                        var defered = $q.defer();
                        var promise = defered.promise;

                        if ($scope.processTypes && $scope.processTypes.length > 0) {
                            defered.resolve();
                        } else {
                            configViewService.getById("CPPStatistics").then(function (result) {
                                if (result.processTypes && result.processTypes.length > 0) {
                                    $scope.processTypes = [];
                                    angular.forEach(result.processTypes, function (item) {
                                        $scope.loadMetadata(item);
                                    });
                                }

                                defered.resolve();
                            }, function (error) {
                                errors.showError(error);
                                defered.reject();
                            });
                        }

                        return promise;
                    };

                    $scope.view = function (paycheck) {
                        $state.go('paycheck-rrhh-detail', { id: paycheck.id });
                    };

                    $scope.cancel = function () {
                        $window.history.back();
                    };

                    $scope.exportToExcel = function () {
                        return $translate(['DocumentOrganizationalUnits', 'ProcessReceptionDateView', 'ProcessState', 'User', 'ProcessName'])
                            .then(function (translated) {
                                var headers = [];
                                var filters = $scope.createFilters();
                                filters.itemPerPage = null;
                                filters.page = null;
                                headers.push({ key: "OrganizationalUnitName", value: translated.DocumentOrganizationalUnits });
                                headers.push({ key: "CreationDate", value: translated.ProcessReceptionDateView });

                                $scope.find.processType.headers.forEach(function (header) {
                                    headers.push({ key: header.systemName, value: header.label });
                                });

                                headers.push({ key: "StateAlias", value: translated.ProcessState });

                                return processService.exportToXLS(filters, headers, 'Estadisticas').then(function (result) {
                                    var d = new Date();

                                    var docName = "Estadisticas";

                                    var success = fileDownloader.saveAs(result.value, docName +
                                        '_' +
                                        d.getUTCFullYear() +
                                        '-' +
                                        (d.getUTCMonth() + 1) +
                                        '-' +
                                        d.getDate() +
                                        '.xlsx');

                                    if (!success) {
                                        errors.showError('Api failed');
                                    }

                                }, function (error) {
                                    errors.showError('Api failed');
                                });
                            });
                    };

                    $scope.changePage = function () {
                        $scope.data.from = 1 + ($scope.data.itemPerPage * ($scope.data.currentPage - 1));
                        $scope.data.to = Math.min($scope.data.itemPerPage * $scope.data.currentPage, $scope.data.totalItems);

                        $scope.paychecksGrid = $scope.paychecks.slice($scope.data.from - 1, $scope.data.to);
                    };

                    $scope.load = function () {
                        $scope.chartData = {};
                        $scope.data = {
                            currentPage: 1,
                            totalItems: 0,
                            itemPerPage: 15,
                            from: 0
                        }

                        $scope.find = storageService.getStatisticsRRhhFilter();

                        $q.all([$scope.loadViewOptions()]).then(function (result) {
                            $scope.loadPreFilters();
                            $scope.executeFind();
                        });
                    };

                    $scope.load();

                }]);
})();